export interface FailedSettledResult {
  title: string;
  reason: unknown;
}

export const getRejectedSettledResults = <T>(results: PromiseSettledResult<T>[], entries: { title: string }[]): FailedSettledResult[] =>
  results
    .map((result, index) => ({ ...result, title: entries[index].title }))
    .filter((r): r is PromiseRejectedResult & { title: string } => r.status === 'rejected')
    .map(r => ({ title: r.title, reason: r.reason }));
